export { default as ShiftplanSeniority } from './shiftplanSeniority.component';
